module.exports = __webpack_public_path__ + "media/assets/images/tenant-portal-tips/heating1-4dac535d82b9a5c2e1f2ec4793af333d.jpg";